/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { AddToEarlyAccessListRequest } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiLandingPageController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-landing-page-controller
   * @name AddToEarlyAccessList
   * @request POST:/api/v1/landing/get-early-access
   */
  addToEarlyAccessList = (data: AddToEarlyAccessListRequest, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/v1/landing/get-early-access`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static addToEarlyAccessListPath = '/v1/landing/get-early-access'
  static addToEarlyAccessListMethod = 'POST'
}
